import { useQuery } from "react-query"
import {
  checkPossibleDuplicateEvent,
  type PossibleDuplicateResponse,
} from "../requests/posts"

interface UseDuplicateEventCheckParams {
  bandId: number | null
  startDatetime: string | null
  venueBandId?: number | null
  enabled: boolean
}

export function useDuplicateEventCheck({
  bandId,
  startDatetime,
  venueBandId,
  enabled,
}: UseDuplicateEventCheckParams) {
  const queryKey = ["possibleDuplicateEvent", bandId, startDatetime, venueBandId]

  const { data, isLoading } = useQuery<PossibleDuplicateResponse>(
    queryKey,
    () =>
      checkPossibleDuplicateEvent(
        bandId as number,
        startDatetime as string,
        venueBandId,
      ),
    {
      enabled: enabled && !!bandId && !!startDatetime,
      staleTime: 30 * 1000,
      retry: false,
    },
  )

  return { duplicate: data?.duplicate ?? null, isLoading }
}
